import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { Box, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import { workQueueActions } from 'store/slices/workQueueSlice';

const OrdersSearchField = ({ onSearchInput }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const inputValue = useSelector((state) => state.workQueue.reconcileShipment.searchInputValue);
  const selectedReconcileId = useSelector(
    (state) => state.workQueue.reconcileShipment.selectedReconcileId
  );

  const debouncedSendInputToParent = useMemo(
    () =>
      debounce((value) => {
        onSearchInput(value);
      }, 500),
    [onSearchInput]
  );

  const handleTextFieldChange = (event) => {
    const newValue = event.target.value;
    dispatch(workQueueActions.setReconcileSearchInput(newValue));

    if (newValue?.length > 0 && newValue?.length < 3) {
      setError(true);
    } else {
      setError(false);
    }

    debouncedSendInputToParent(newValue);
  };

  return (
    <Box sx={{ height: '35px' }}>
      <TextField
        size='small'
        label='Search Orders'
        value={inputValue}
        disabled={!selectedReconcileId}
        error={error}
        helperText={error ? 'Enter at least 3 characters' : ''}
        onChange={handleTextFieldChange}
        InputProps={{
          endAdornment: <Search />,
        }}
        sx={{
          width: 300,
          '& .MuiInputBase-root': {
            height: '35px',
          },
          '& .MuiOutlinedInput-input': {
            padding: '4px 8px',
          },
        }}
      />
    </Box>
  );
};

OrdersSearchField.propTypes = {
  onSearchInput: PropTypes.func.isRequired,
};

export default OrdersSearchField;
